/**
 * Indicateur de chargement accessible.
 *
 * `role="status"` + `aria-live="polite"` : l’attente est annoncée sans interrompre la lecture.
 * Le texte est traduit (par défaut `ui:commun.chargement`).
 */
import { useTranslation } from 'react-i18next';

export interface ProprietesChargement {
  readonly texte?: string;
}

export function Chargement({ texte }: ProprietesChargement) {
  const { t } = useTranslation();
  return (
    <div className="chargement" role="status" aria-live="polite">
      <span className="tourniquet" aria-hidden="true" />
      <span>{texte ?? t('commun.chargement')}</span>
    </div>
  );
}
